import { useState, useEffect } from "react";
import { ReportAPINew } from "@api";
import { LinkWithImage, Pagination } from "@components";
import { Row, Col } from "react-bootstrap";
import queryString from "query-string";

import "./AnnualReportList.scss";

function AnnualReportList({ page, active }) {
  const [annualReport, setAnnualReport] = useState({});

  useEffect(() => {
    const loadData = async function () {
      const filter = {
        cat: "laporan_tahunan",
        orderBy: "desc",        
        page: page,
      };
      const reportData = await ReportAPINew(queryString.stringify(filter));
      setAnnualReport(reportData.data.data);
    };

    if (active) {
      loadData();
    }
  }, [page, active]);

  const createPagination = () => {
    const { total, per_page } = annualReport;
    return {
      totalItems: total,
      currentPage: +page,
      limit: per_page,
    }
  }

  return (
    <div className="annual-report-list">
      <Row className="">
        {annualReport != null
          ? annualReport.result?.map((data, i) => {
              return (
                <Col xs="12" md="4" className="pb-4" key={i}>
                  <LinkWithImage
                    image={data.image}
                    title={data.title}
                    file={data.file}
                  />
                </Col>
              );
            })
          : ""}
      </Row>
      <nav className="pagination-box" aria-label="Annual Report Pagination">
        <ul className="pagination">
          <Pagination {...createPagination()} />
        </ul>
      </nav>
    </div>
  );
}

export default AnnualReportList;
